"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function valueToString(value) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
  return typeof value === 'number' ? "".concat(value).concat(unit) : value;
}

exports["default"] = valueToString;